import {ChangeDetectorRef, Component, ElementRef,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../../../model/api/field-record";
import {FieldRequest} from "../../../../../model/api/field-request";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {CommonFieldService} from "../../../../../services/common/common-field.service";
import {AccountType} from "../../../../../model/exchange/account-type";
import {ClearingAllocationService} from "../../../../../services/clearing/clearing-allocation.service";
import {Contract} from "../../../../../model/exchange/contract";
import {Trade} from "../../../../../model/clearing/trade";
import {TradingEnvironment} from "../../../../../model/exchange/trading-environment";
import {AllocationFormBaseComponent} from "./allocation-form-base.component";
import {ExchangeContractService} from "../../../../../services/exchange/exchange-contract.service";
import {ThemeService} from "../../../../../services/tools/theme.service";
import {AccountDefinition} from "../../../../../model/customer/account-definition";
import {AppConfigService} from "../../../../../services/app-config.service";
import {CcStorageService} from "../../../../../services/common/cc-storage.service";
import TYPE = FormFieldConfig.TYPE;
import Side = Trade.Side;
import OpenClose = AccountDefinition.OpenClose;
import {ApsIdFormat} from "../../../../../model/clearing/aps-id-format";
import {FieldsService} from "../../../../../services/common/fields-service";
import CallPut = Trade.CallPut;

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ]
})
export class SplitAllocationFormBaseComponent extends AllocationFormBaseComponent {

  tradingEnvironments: FieldRecord<TradingEnvironment>[] = []
  displayedTradingEnvs: FieldRecord<TradingEnvironment>[] = []
  formContracts: Contract[] = []
  // contractFields: FieldRecord<any>[] = []
  currentContractsRequest: string[];
  clearingStateColorMap: any = {};
  clearingExchApsIdFormatMap: any = {string: ApsIdFormat};

  constructor(el: ElementRef,
              cdref: ChangeDetectorRef,
              protected allocationService: ClearingAllocationService,
              protected exchangeContractService: ExchangeContractService,
              protected commonFieldService: CommonFieldService,
              appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              public themeService: ThemeService,
              storageService: CcStorageService,
              fieldsService: FieldsService) {
    super(el, cdref, allocationService, commonFieldService,
      messageService, confirmationService, translateService, fieldsService,
      storageService, appConfigService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.refreshConfig();
  }

  public loadData() {
    super.loadData();
    // init data
    this.clearingStateColorMap = this.appConfigService.clearingStateColorMap;
    this.clearingExchApsIdFormatMap = this.appConfigService.clearingExchApsIdFormatMap;

    this.fieldsService.loadField(this.tradingEnvironments, () => this.commonFieldService.getTradingEnvironments(FieldRequest.DEFAULT()), this.tracker, (records) => {
      this.filterTradingEnvs();
    });
    // this.filterContracts();
  }

  protected refreshConfig() {

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            column: 1,
            type: TYPE.NONE,
            icon: id => {
              let sideClass = this.formRecord.side === Side.SELL ? 'form-sell-side' : 'form-buy-side';
              return sideClass;
            },
            iconValue: event => this.formRecord.side
          },
          // {
          //   column: 2,
          //   type: TYPE.NONE,
          // },
          // {
          //   field: 'owner',
          //   required: true,
          //   column: 2,
          //   optionValue: 'text',
          //   type: TYPE.DROPDOWN,
          //   options: () => this.owners,
          //   changed: event => {
          //     this.filterCustomers();
          //   },
          //   hidden: () => this.owners.length === 1,
          // },
          // {
          //   column: 2,
          //   type: TYPE.NONE,
          //   hidden: () => this.owners.length != 1,
          // },
          {
            field: 'exchangeCode',
            column: 1,
            type: TYPE.NONE,
            icon: id => {
              if (this.currentExchanges && this.currentExchanges.length > 0) {
                return this.currentExchanges[0].country ? 'flag-icon-form flag-icon flag-icon-' + this.currentExchanges[0].country.toLowerCase() : '';
              } else {
                return '';
              }
            },
            iconValue: id => this.formRecord.exchangeCode
          },
          {
            field: 'contractCode',
            column: 2,
            type: TYPE.NONE,
            // options: () => this.contractFields,
            style: record => 'padding-left: 6px',
            icon: id => '',
            iconValue: id => this.formRecord.contractCode/* + '<i class="cc-ico ng-star-inserted">'+(this.formRecord.callPut == CallPut.NONE ? 'F' : 'O')+'</i>'*/,
          },
          {
            field: 'tradeType',
            column: 1,
            type: TYPE.TEXT,
          },
          {
            field: 'tradingEnvironment',
            filter: true,
            column: 1,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.getDistinctOpts(this.displayedTradingEnvs),
          },
          {
            field: 'maturity',
            required: true,
            column: 2,
            type: TYPE.TEXT,
          },
          {
            column: 4,
            type: TYPE.NONE,
          },
          {
            field: 'orderReference',
            column: 2,
            type: TYPE.TEXT,
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.orderReference = inputField.value;
              inputField.setSelectionRange(start, end);
            },
            focused: true
          },
          {
            field: 'apsGroupId',
            filter: true,
            column: 2,
            type: TYPE.TEXT,
            leftButton: {
              icon: 'fa-solid fa-arrow-right',
              command: event => {
                if (this.clearingExchApsIdFormatMap[this.formRecord.exchangeCode]) {
                  this.formRecord.apsGroupId = ApsIdFormat.format(this.clearingExchApsIdFormatMap[this.formRecord.exchangeCode], this.formRecord.orderReference);
                } else {
                  this.formRecord.apsGroupId = this.formRecord.orderReference;
                }
                this.formRecord.allocations.forEach(allocation => allocation.apsGroupId = this.formRecord.apsGroupId);
                this.refreshApsClass();
                this.ccFormDialog.reloadFieldValueMap();
              }
            },
            input: (event, formRecord, inputField) => {
              var start = inputField.selectionStart;
              var end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.apsGroupId = inputField.value;
              inputField.setSelectionRange(start, end);
              this.formRecord.allocations.forEach(allocation => allocation.apsGroupId = inputField.value);
              this.refreshApsClass();
              this.ccFormDialog.reloadFieldValueMap();
            },
            disabled: record => !this.apsManagement()
          },
          {
            field: 'volume',
            required: true,
            column: 1,
            type: TYPE.INTEGER,
          },
          {
            field: 'price',
            column: 1,
            type: TYPE.DECIMAL,
          },
          {
            field: 'callPut',
            column: 1,
            type: TYPE.NONE,
            icon: id => '',
            iconValue: id => this.formRecord.callPut,
            hidden: record => !this.formRecord.callPut || this.formRecord.callPut && this.formRecord.callPut == CallPut.NONE
          },
          {
            field: 'strike',
            column: 1,
            type: TYPE.NONE,
            icon: id => '',
            iconValue: id => this.formRecord.strike,
            hidden: record => !this.formRecord.callPut || this.formRecord.callPut && this.formRecord.callPut == CallPut.NONE
          },
          {
            field: 'customOrderReference',
            column: this.formRecord && (!this.formRecord.callPut || this.formRecord.callPut && this.formRecord.callPut == CallPut.NONE) ? 2 : 1,
            type: TYPE.TEXT,
          },
          {
            column: 1,
            type: TYPE.NONE,
            hidden: record => this.formRecord.callPut && this.formRecord.callPut != CallPut.NONE
          },
          {
            field: 'desk',
            column: 1,
            type: TYPE.TEXT,
          },
          {
            field: 'traderMemo',
            column: 1,
            type: TYPE.TEXT,
            max: 20,
            input: (event, formRecord, inputField) => {
              let start = inputField.selectionStart;
              let end = inputField.selectionEnd;
              inputField.value = inputField.value.toUpperCase();
              formRecord.traderMemo = inputField.value;
              inputField.setSelectionRange(start, end);
              this.originTraderMemo = formRecord.traderMemo;
            },
            hidden: record => {
              return !this.isRoleTraderMemoUpdate() || !this.appConfigService.iceTraderMemoFeature || !this.manageTraderMemo();
            }
          },
          {
            column: 1,
            type: TYPE.NONE,
            hidden: record => {
              return this.isRoleTraderMemoUpdate() && this.appConfigService.iceTraderMemoFeature && this.manageTraderMemo();
            }
          },
        ]
      },
      {
        group: '',
        fields: [
          {
            field: 'allocations',
            required: true,
            filter: true,
            column: 12,
            type: TYPE.ADDDELETEFIELD,
            validate: record => this.validateSplits(record),
            richFieldConfig: {
              canDelete: formRecords => this.canDeleteSplit(formRecords),
              canAdd: formRecords => this.canAddSplit(formRecords),
              addNew: formRecords => this.addSplit(formRecords),
              fields: [
                {
                  group: '',
                  fields: this.getMainFields()
                },
                {
                  group: '',
                  hidden: record => AccountType.GIVE_UP_CODE === record.accountTypeCode,
                  fields: this.getClearingFields()
                },
                {
                  group: '',
                  hidden: record => AccountType.GIVE_UP_CODE != record.accountTypeCode,
                  fields: this.getGiveUpFields()
                },
              ]
            }
          },
        ]
      },
      {
        fields: [
          {
            column: 2,
            type: TYPE.NONE,
            class: 'form-info over-bottom',
            icon: id => {
              const remaining = this.getRemainingVolume();
              return remaining == 0 ?
                'form-info-green' : (remaining < 0 ? 'form-info-red'
                  : 'form-info-orange');
            },
            iconValue: event => {
              const remaining = this.getRemainingVolume();
              if (remaining == 0) {
                return this.translateService.instant('page.' + this.transPartKey + '.form.message.noRemaining'
                  , {remaining: remaining + '/' + this.formRecord.volume});
              } else if (remaining >= 0) {
                return this.translateService.instant('page.' + this.transPartKey + '.form.message.remaining'
                  , {remaining: remaining + '/' + this.formRecord.volume});
              }
              return this.translateService.instant('page.' + this.transPartKey + '.form.message.remainingAbove'
                , {remaining: remaining + '/' + this.formRecord.volume});
            }
          }]
      }
    ];
  }

  private getMainFields(): FormFieldConfig[] {
    const mainFields: FormFieldConfig[] = [
      {
        // field: 'state',
        class: 'form-info form-info-left',
        column: 1,
        type: TYPE.NONE,
        disabled: record => true,
        hidden: record => !this.formRecord.orderIds || this.formRecord.orderIds.length == 0,
        style: record => {
          if (record['state'] && this.clearingStateColorMap) {
            return 'font-weight: 500; font-size: 10px; color:var(--' + this.clearingStateColorMap[record['state']].toLowerCase() + ') !important;';
          }
          return '';
        },
        icon: id => '',
        iconValue: (value, record) => record['state']
      },
      {
        field: 'allocation',
        required: true,
        column: 2,
        type: TYPE.INTEGER,
      },
      {
        field: 'apsGroupId',
        column: 2,
        type: TYPE.TEXT,
        input: (event, formRecord, inputField) => {
          var start = inputField.selectionStart;
          var end = inputField.selectionEnd;
          inputField.value = inputField.value.toUpperCase();
          formRecord.apsGroupId = inputField.value;
          inputField.setSelectionRange(start, end);
          queueMicrotask(() => {
            this.refreshApsClass();
            this.ccFormDialog.reloadFieldValueMap();
          });
        },
        disabled: record => !this.apsManagement()
      },
      {
        field: 'customerName',
        filter: true,
        column: 2,
        type: TYPE.AUTOCOMPLETE,
        options: (record, query) => {
          const opts: FieldRecord<any>[] = this.getDistinctOpts(this.displayedCustomers)
          return opts;
        },
        changed: (event, event2) => {
          queueMicrotask(() => this.forceCustomerValues(event2, event.text, event.id));
        }
      },
      {
        field: 'accountCode',
        column: 2,
        type: TYPE.AUTOCOMPLETE,
        options: (record, query) => {
          return this.getDistinctOpts(this.filterAccounts(record, query));
        },
        changed: (event, record) => {
          queueMicrotask(() => this.forceAccountValues(record, event.text));
        }
      },
      {
        field: 'accountTypeCode',
        filter: true,
        column: 1,
        type: TYPE.AUTOCOMPLETE,
        options: () => this.getDistinctOpts(this.displayedAccountTypes),
      }];
    if (this.appConfigService.billingEnabled) {
      mainFields.push(
        {
          field: 'execTrader',
          column: 1,
          type: TYPE.AUTOCOMPLETE,
          options: (record) => this.getDistinctOpts(this.execTraders),
          changed: (event, record) => {
            queueMicrotask(() => this.setBrokerageRate(record));
          }
        });
    }
    mainFields.push(
      {
        field: 'traderName',
        filter: true,
        column: this.appConfigService.billingEnabled ? 1 : 2,
        type: TYPE.AUTOCOMPLETE,
        options: (record) => this.getDistinctOpts(this.filterTraders(record)),
      });

    return mainFields;
  }


  private getClearingFields(): FormFieldConfig[] {
    const fields: FormFieldConfig[] = [
      {
        column: 1,
        type: TYPE.NONE,
        hidden: record => !this.formRecord.orderIds || this.formRecord.orderIds.length == 0,
      },
      {
        field: 'reference1',
        column: 2,
        type: TYPE.TEXT,
        input: (event, formRecord, inputField) => {
          var start = inputField.selectionStart;
          var end = inputField.selectionEnd;
          inputField.value = inputField.value.toUpperCase();
          formRecord.reference1 = inputField.value;
          inputField.setSelectionRange(start, end);
        },
      },
      {
        field: 'reference2',
        column: 2,
        type: TYPE.TEXT
      },
      {
        field: 'reference3',
        column: 2,
        type: TYPE.TEXT
      },
      {
        field: 'openClose',
        filter: true,
        column: 2,
        type: TYPE.DROPDOWN,
        options: () => this.openCloses,
        hidden: () => {
          return !this.openCloseManagement();
        }
      },
      {
        column: 2,
        type: TYPE.NONE,
        hidden: () => {
          return this.openCloseManagement();
        }
      }
    ];
    if (this.appConfigService.billingEnabled) {
      fields.push(
        {
          field: 'moneyOwner',
          column: 1,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.getDistinctOpts(this.moneyOwners),
        },
        {
          field: 'rate',
          column: 1,
          type: TYPE.TEXT,
        });
    } else {
      fields.push({
        column: 1,
        type: TYPE.NONE,
      });
    }
    fields.push({
      field: 'currency',
      column: 1,
      type: TYPE.TEXT,
      input: (event, formRecord, inputField) => {
        var start = inputField.selectionStart;
        var end = inputField.selectionEnd;
        inputField.value = inputField.value.toUpperCase();
        formRecord.currency = inputField.value;
        inputField.setSelectionRange(start, end);
      },
    });

    return fields;
  }

  private getGiveUpFields(): FormFieldConfig[] {
    const fields: FormFieldConfig[] = [
      {
        field: 'residual',
        column: 1,
        class: 'form-info form-info-left',
        type: TYPE.NONE,
        icon: (id, record) => {
          return record['residual'] && record['residual'] >= 0 ? 'form-info-green' : 'form-info-orange';
        },
        iconValue: (value, record) => record['residual'] ? Math.round(Number(record['residual']) * 10000) / 10000 + '' : '',
        disabled: record => true,
        hidden: record => !record['residual']
      },
      {
        column: 1,
        type: TYPE.NONE,
        hidden: record => record['residual'] || !this.formRecord.orderIds || this.formRecord.orderIds.length == 0
      },
      {
        field: 'giveUpBrokerCode',
        column: 2,
        type: TYPE.TEXT
      },
      {
        field: 'giveUpMessage',
        column: 2,
        type: TYPE.TEXT,
        input: (event, formRecord, inputField) => {
          var start = inputField.selectionStart;
          var end = inputField.selectionEnd;
          inputField.value = inputField.value.toUpperCase();
          formRecord.giveUpMessage = inputField.value;
          inputField.setSelectionRange(start, end);
        },
      },
      {
        field: 'giveUpMessage2',
        column: 2,
        type: TYPE.TEXT,
        hidden: record => !this.manageGiveUpMssg23()
      },
      {
        field: 'giveUpMessage3',
        column: 2,
        type: TYPE.TEXT,
        hidden: record => {
          return !this.manageGiveUpMssg23()
        }
      },
      {
        field: 'broker',
        column: this.appConfigService.billingEnabled ? 1 : 2,
        type: TYPE.TEXT,
        hidden: record => {
          return this.manageGiveUpMssg23()
        }
      },
      {
        column: this.appConfigService.billingEnabled ? 1 : 2,
        type: TYPE.NONE,
        hidden: record => this.manageGiveUpMssg23()
      },
      {
        field: 'giveupAccountType',
        filter: true,
        column: 1,
        type: TYPE.AUTOCOMPLETE,
        options: () => this.getDistinctOpts(this.displayedGUpAccountTypes),
      },
    ];
    if (this.appConfigService.billingEnabled) {
      fields.push(
        {
          field: 'moneyOwner',
          column: 1,
          type: TYPE.AUTOCOMPLETE,
          options: () => this.getDistinctOpts(this.moneyOwners),
        },
        {
          field: 'rate',
          column: 1,
          type: TYPE.TEXT,
        });
    }
    fields.push({
      field: 'currency',
      column: 1,
      type: TYPE.TEXT,
      input: (event, formRecord, inputField) => {
        var start = inputField.selectionStart;
        var end = inputField.selectionEnd;
        inputField.value = inputField.value.toUpperCase();
        formRecord.currency = inputField.value;
        inputField.setSelectionRange(start, end);
      },
    });

    return fields;
  }

  private getRemainingVolume() {
    let splitTotVolume: number = 0;
    this.formRecord.allocations.forEach(formRecord => {
      const numberValue = parseInt(formRecord.allocation + '');
      if (Number.isInteger(numberValue))
        splitTotVolume += numberValue;
    });
    return this.formRecord.volume - splitTotVolume;
  }

  protected filterTradingEnvs() {
    if (this.tradingEnvironments && this.formRecord) {
      this.displayedTradingEnvs = this.tradingEnvironments.filter(field => {
        return !this.formRecord.clearingHouse || this.formRecord.clearingHouse === field.value.clearingHouse;
      });
    } else {
      this.displayedTradingEnvs = [];
    }
  }

  // protected filterContracts() {
  //   if (this.formRecord && this.formRecord.exchangeCode) {
  //     const contractIdParts = [this.exchangeContractService.getContractIdPart(this.formRecord)];
  //     if (!this.currentContractsRequest || JSON.stringify(this.currentContractsRequest) != JSON.stringify(contractIdParts)) {
  //       this.currentContractsRequest = contractIdParts;
  //       this.exchangeContractService.getForIdParts(contractIdParts).subscribe(apiValidation => {
  //           if (apiValidation.success) {
  //             this.formContracts = apiValidation.item;
  //             // this.contractFields = apiValidation.item.map(value => new FieldRecord<any>(value.id, value.code));
  //             this.refreshFieldData();
  //           } else {
  //             this.errorMessage(apiValidation.message);
  //           }
  //         }
  //       );
  //     }
  //   } else {
  //     this.formContracts = []
  //     // this.contractFields = []
  //     this.refreshFieldData();
  //   }
  // }

  canDeleteSplit(formRecords: any): boolean {
    return this.formRecord.allocations.length > 1;
  }

  canAddSplit(formRecords: any): boolean {
    let splitTotVolume: number = 0;
    this.formRecord.allocations.forEach(formRecord => {
      splitTotVolume += parseInt(formRecord.allocation);
    });
    return splitTotVolume < this.formRecord.volume;
  }

  addSplit(formRecords: any) {
    let splitTotVolume: number = 0;
    this.formRecord.allocations.forEach(formRecord => {
      splitTotVolume += parseInt(formRecord.allocation);
    });
    const customerName = this.formRecord.allocations.length > 0 ?
      this.formRecord.allocations[this.formRecord.allocations.length - 1].customerName : undefined;
    const customerId = this.formRecord.allocations.length > 0 ?
      this.formRecord.allocations[this.formRecord.allocations.length - 1].customerId : undefined;
    this.formRecord.allocations.push({
      allocation: this.formRecord.volume - splitTotVolume,
      apsGroupId: this.formRecord.apsGroupId,
      accountTypeCode: AccountType.GIVE_UP_CODE,
      openClose: OpenClose.NO,
      clearingHouse: this.formRecord.clearingHouse,
      exchangeCode: this.formRecord.exchangeCode,
      customerName: customerName,
      customerId: customerId,
    });

    this.validateSplits(this.formRecord);
  }

  validateSplits(record: any): string {
    let splitTotVolume: number = 0;
    let uniqueApsId = undefined;
    let isApsIdUnique = true;

    record.allocations.forEach(formRecord => {
      splitTotVolume += parseInt(formRecord.allocation);
      if (uniqueApsId && uniqueApsId !== formRecord.apsGroupId) {
        this.formRecord.apsGroupId = undefined;
        isApsIdUnique = false;
      }
      uniqueApsId = formRecord.apsGroupId
    });
    if (isApsIdUnique) {
      this.formRecord.apsGroupId = uniqueApsId;
    }
    if (splitTotVolume != this.formRecord.volume)
      return 'page.' + this.transPartKey + '.form.message.volumeDoesNotMatch';
    return '';
  }

  protected refreshApsClass() {
    super.refreshApsClass();
  }
}
